"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactEmotion = _interopRequireWildcard(require("react-emotion"));
var _propTypes = require("prop-types");
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Wrapper = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "e1rcjezn0"
})("position:relative;display:flex;min-height:360px;flex-direction:column;border-radius:2px;box-shadow:0 2px 4px 0 rgba(0,0,0,0.05);overflow:hidden;");
var Image = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "e1rcjezn1"
})("width:100%;height:", function (props) {
  return props.big ? '160px' : '120px';
}, ";background-image:url(", function (props) {
  return props.src;
}, ");background-size:cover;background-position:center center;background-repeat:no-repeat;");
var Card = /*#__PURE__*/
(0, _reactEmotion.default)('div', {
  target: "e1rcjezn2"
})("height:auto;padding:10px 20px 25px 20px;background-color:#fff;text-align:center;display:flex;flex-direction:column;justify-content:space-between;flex-grow:1;h4{color:#424242;margin:0 0 10px;}p{font-size:14px;width:100%;max-width:200px;}");
var primaryColor = function primaryColor(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/(
    (0, _reactEmotion.css)({
      color: theme.primaryColor
    })
  );
};
var smallFont = /*#__PURE__*/
(0, _reactEmotion.css)({
  fontSize: '0.875rem'
});
var grayColor = /*#__PURE__*/
(0, _reactEmotion.css)({
  color: '#545761',
  margin: '0 auto',
  'a, a:visited, a:hover': {
    color: '#545761'
  }
});
var Title = /*#__PURE__*/
(0, _reactEmotion.default)('h3', {
  target: "e1rcjezn3"
})(primaryColor, {
  fontSize: '1rem'
});
var Description = /*#__PURE__*/
(0, _reactEmotion.default)('p', {
  target: "e1rcjezn4"
})(grayColor, smallFont, {
  marginBottom: 40
});
var Footer = /*#__PURE__*/
(0, _reactEmotion.default)('p', {
  target: "e1rcjezn5"
})(grayColor, smallFont, {});
var Link = /*#__PURE__*/
(0, _reactEmotion.default)('a', {
  target: "e1rcjezn6"
})(primaryColor, smallFont, {
  textDecoration: 'none',
  fontWeight: 600
});
var ImageCard = function ImageCard(_ref2) {
  var src = _ref2.src,
    big = _ref2.big,
    title = _ref2.title,
    description = _ref2.description,
    footer = _ref2.footer,
    link = _ref2.link,
    linkText = _ref2.linkText;
  return _react.default.createElement(Wrapper, null, _react.default.createElement(Image, {
    src: src,
    big: big
  }), _react.default.createElement(Card, null, _react.default.createElement(Title, null, title), _react.default.createElement(Description, null, description), _react.default.createElement(Footer, null, footer), _react.default.createElement(Link, {
    href: link,
    target: "_blank",
    rel: "noreferrer noopener"
  }, linkText)));
};
ImageCard.defaultProps = {
  linkText: 'READ MORE'
};
ImageCard.propTypes = {
  src: _propTypes.string,
  title: _propTypes.string,
  description: _propTypes.string,
  footer: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  link: _propTypes.string,
  big: _propTypes.bool,
  children: _propTypes.node,
  linkText: _propTypes.string
};
var _default = ImageCard;
exports.default = _default;